import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import '../assets/css/notFoundPage.css';
import {Container} from "reactstrap";
import {Col, Row} from "react-bootstrap";
function NotFound() {
    const navigate = useNavigate();

    return (
        <Container>
            <Row>
                <Col sm={{ span: 10, offset: 1 }} className="text-center">
                    <div className="four_zero_four_bg text-center">
                        <h1 className="text-center">404</h1>
                    </div>
                    <div className="contant_box_404 text-center">
                        <h3 className="h2">Look like you're lost</h3>
                        <p>The page you are looking for is not available!</p>
                        <Link to="/" className="link_404">Go to Home</Link>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default NotFound;